import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule} from '@angular/common/http';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AccesoDenegadoComponent } from './componentes/acceso-denegado/acceso-denegado.component';
import { PaginaNoEncontradaComponent } from './componentes/pagina-no-encontrada/pagina-no-encontrada.component';
import { LoginComponent } from './componentes/login/login.component';
import { LayoutComponent } from './componentes/layout/layout.component';
import { MenuPerfilComponent } from './componentes/menu-perfil/menu-perfil.component';
import { MenuCertificacionesComponent } from './componentes/menu-certificaciones/menu-certificaciones.component';
import { MenuOpcionesCertificadosComponent } from './componentes/menu-opciones-certificados/menu-opciones-certificados.component';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { ValidacionCertificadoComponent } from './componentes/validacion-certificado/validacion-certificado.component';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';

@NgModule({
  declarations: [
    AppComponent,
    AccesoDenegadoComponent,
    PaginaNoEncontradaComponent,
    LoginComponent,
    LayoutComponent,
    MenuPerfilComponent,
    MenuCertificacionesComponent,
    MenuOpcionesCertificadosComponent,
    ValidacionCertificadoComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    CoreModule,
    SharedModule,
    NgxExtendedPdfViewerModule
  ],
  providers: [{provide: LocationStrategy , useClass: HashLocationStrategy}],
  bootstrap: [AppComponent]
})
export class AppModule { }
